import {
  DashboardChartType,
  TDashboardCardSource,
} from "../../dynamic-dashboard.models";

export const CARD_SOURCE_OPTIONS: {
  value: TDashboardCardSource;
  labelKey: string;
}[] = [
  { value: "report", labelKey: "dashboard.dynamic.cardSource.report" },
  { value: "system", labelKey: "dashboard.dynamic.cardSource.system" },
];

export const CHART_TYPE_OPTIONS: {
  value: DashboardChartType;
  labelKey: string;
}[] = [
  {
    value: DashboardChartType.HorizontalBar,
    labelKey: "dashboard.dynamic.chartType.horizontalBar",
  },
  {
    value: DashboardChartType.VerticalBar,
    labelKey: "dashboard.dynamic.chartType.verticalBar",
  },
  {
    value: DashboardChartType.Pie,
    labelKey: "dashboard.dynamic.chartType.pie",
  },
  {
    value: DashboardChartType.Line,
    labelKey: "dashboard.dynamic.chartType.line",
  },
  {
    value: DashboardChartType.Stacked,
    labelKey: "dashboard.dynamic.chartType.stacked",
  },
  {
    value: DashboardChartType.Clustered,
    labelKey: "dashboard.dynamic.chartType.clustered",
  },
  {
    value: DashboardChartType.Stat,
    labelKey: "dashboard.dynamic.chartType.number",
  },
];

export const BACKDROP_SX = { backgroundColor: "rgba(0, 0, 0, 0.3)" };
